// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderSlTpBase } from './OrderSlTpBase';
export class TrailingStop extends OrderSlTpBase {
    constructor() {
        super(...arguments);
        this.RealTrStopPrice = null;
    }
}
